import { lazy } from 'react';
import withSuspense from '../../../helpers/withSuspense.jsx';
import ButtonSkeleton from '../../../skeleton_loaders/common/ButtonSkeleton.jsx';

const DashboardIconSelect = withSuspense(lazy(() => import('./DashboardIconSelect.jsx')), ButtonSkeleton);

export default DashboardIconSelect;
